import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import { AtomicLogo } from "../../../assets/AtomicLogo";

interface PasswordCreationProps {
  email: string;
  onSwitchToLanding: () => void;
  onSwitchToPasswordEntry: () => void;
  onSignUpSuccess: () => void;
}

// PENTEST HARDENING (self sign-up disabled): this component used to call
// Amplify's signUp() to create a brand-new Cognito user for any email that
// didn't already exist. It no longer creates accounts at all — accounts on
// the production pool are admin-created only. A first login for an
// admin-invited user is handled entirely by PasswordEntryComponent's
// CONFIRM_SIGN_IN_WITH_NEW_PASSWORD / NEW_PASSWORD_REQUIRED challenge, not by
// this component; that flow is unaffected by this change.
//
// Kept (not deleted) in case self sign-up returns; if it does, this is where
// the signUp()/confirmSignUp() call and the "Create your account" form used
// to live.
export const PasswordCreationComponent = ({
  email,
  onSwitchToLanding,
  onSwitchToPasswordEntry,
}: PasswordCreationProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#fafafa",
        padding: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 400,
          width: "100%",
          borderRadius: 2,
          border: "1px solid #e0e0e0",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
        }}
      >
        <CardContent sx={{ padding: 4 }}>
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Box sx={{ mb: 2 }}>
              <AtomicLogo width={64} height={64} />
            </Box>
            <Typography variant="h4" component="h1" gutterBottom>
              No account found
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Ask your administrator for an invitation to {email}.
            </Typography>
          </Box>

          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={onSwitchToPasswordEntry}
            sx={{
              mb: 2,
              py: 1.5,
              backgroundColor: "#3877F7",
              "&:hover": {
                backgroundColor: "#2d5fd6",
              },
            }}
          >
            I already have an account
          </Button>

          <Box sx={{ textAlign: "center" }}>
            <Button
              component="button"
              type="button"
              variant="text"
              onClick={onSwitchToLanding}
              sx={{ textDecoration: "none" }}
            >
              ← Use a different email
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
